<!-- 联报sku -->
<template>
  <div class="full-reduction-sku-info">
    <van-popup
        v-model="showSku"
        round
        position="bottom"
        duration="0.2"
        :style="{ 'min-height': '35%', 'max-height': '62%' }"
    >
      <div class="title">
        <div class="empty"></div>
        <div class="title-tool">
          请选择规格
        </div>
        <img src="../../../assets/img/components/wechatBinding/icon_close.png" alt="" @click="close()"/>
      </div>
      <div class="sku_list">
        <div class="sku_list_detial" v-for="(item, n) in productSpecJson" :key="n">
          <h2>{{ item.specName }}</h2>
          <ul>
            <li
                @click="chooseSkuInfo(list.name, n, $event, index)"
                :class="{ noneActive: !list.isShow, active: subIndex[n] == index }"
                v-for="(list, index) in item.options"
                :key="index"
            >
              {{ list.name }}
            </li>
          </ul>
        </div>
      </div>
      <button class="sub" @click="subSku">确定</button>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      showSku: false,
      productSpecJson: [], // 展示在页面的sku规格
      selectArr: [], // 选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中
      selectSku: {}, // 选中的sku信息
      someOne: null, // 可用的一条sku，用于展示默认的sku
    };
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    // 弹窗展开时，回显sku选中的状态
    showSku() {
      if (this.showSku) {
        this.setDefault(this.courseInfo.recommendFullPromotionSkuRespList);
      }
    },
  },
  mounted() {
    // console.log(this.courseInfo, 888);
    this.modifySkuRespVOList();
  },
  methods: {
    close() {
      this.showSku = false;
      this.selectSku = {};
      this.selectArr = [];
    },
    subSku() {
      this.showSku = false;
      this.sendSku(this.selectSku, 'click');
    },
    // 选中sku属性
    chooseSkuInfo(item, n, event, index) {
      if (this.selectArr[n] !== item) {
        [this.selectArr[n], this.subIndex[n]] = [item, index];
      } else {
        this.selectSku = {};
        [this.selectArr[n], this.subIndex[n]] = ['', '-1'];
      }
      this.checkItem();
    },
    checkItem() {
      const self = this;
      const result = this.selectArr; // 定义数组储存被选中的值
      this.productSpecJson.forEach((i) => {
        result[i] = self.selectArr[i] ? self.selectArr[i] : '';
      });
      this.productSpecJson.forEach((element, i) => {
        const last = result[i];
        element.options.forEach((k) => {
          result[i] = k.name;
          Object.assign(k, { isShow: this.someOne ? this.isMay(result) : false }); // isShow来判断是否可以选择
        });
        result[i] = last; // 还原，目的是记录点下去那个值
      });
      if (this.shopItemInfo[result]) {
        this.selectSku = this.shopItemInfo[result];
      }
      self.$forceUpdate(); // 重绘
    },
    // 能否被选中
    isMay(result) {
      result.forEach((item) => {
        const res = item === '';
        return res;
      });
      // 库存校验
      const isStock = this.shopItemInfo[result];
      return isStock;
    },
    // 修改数据结构,将选中的值作为key
    modifySkuRespVOList() {
      const { recommendFullPromotionSkuRespList, productSpecJson } = this.courseInfo;
      const isDefault = recommendFullPromotionSkuRespList
          && recommendFullPromotionSkuRespList.find((ele) => ele.isDefault === 1);
      if (isDefault) {
        this.selectSku = isDefault;
        this.sendSku(isDefault);
        return;
      }
      if (!recommendFullPromotionSkuRespList) {
        return;
      }
      recommendFullPromotionSkuRespList.map((item) => {
        const list = [];
        JSON.parse(item.specJson).map((element) => {
          list.push(element.value);
          return true;
        });
        this.shopItemInfo[String(list)] = item;
        return true;
      });
      if (productSpecJson) {
        JSON.parse(productSpecJson).forEach((item) => {
          const list = [];
          if (item.options) {
            item.options.map((element) => {
              list.push({
                name: element,
              });
              return true;
            });
            Object.assign(item, { options: list });
            this.productSpecJson.push(item);
          }
        });
      }
      this.setDefault(recommendFullPromotionSkuRespList);
      this.checkItem();
    },
    // 默认选中一个有效的sku
    setDefault(recommendFullPromotionSkuRespList) {
      const defautIdx = [];
      const defautName = [];
      if (this.courseInfo.skuInfo) {
        this.someOne = this.courseInfo.skuInfo;
      } else {
        // eslint-disable-next-line prefer-destructuring
        this.someOne = recommendFullPromotionSkuRespList[0];
      }
      if (!this.someOne) return;
      // console.log(this.someOne.specJson,this.productSpecJson)
      this.productSpecJson.forEach((item) => {
        item.options.forEach((list, i) => {
          // console.log(list.name, 666, this.someOne.skuSpecJson);
          if (this.someOne.specJson.indexOf(list.name) > -1) {
            defautName.push(list.name);
            defautIdx.push(i);
          }
        });
      });
      this.subIndex = defautIdx;
      this.selectArr = defautName;
      this.sendSku(this.someOne);
    },
    // 将选中的sku,回传到父组件
    sendSku(sku, way) {
      const skuInfo = JSON.parse(JSON.stringify(sku));
      skuInfo.skuName = JSON.parse(JSON.stringify(this.selectArr));
      skuInfo.productId = this.courseInfo.productId;
      this.$emit('triggerSku', skuInfo, way);
    },
  },
};
</script>

<style lang="scss" scoped>
.full-reduction-sku-info {
  ::v-deep .van-popup__close-icon {
    position: absolute;
    padding: 0 0 0 0;
    color: #666;
    font-weight: 300;
    font-size: 29px;
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 36px;

    .title-tool {
      padding: 29px 0;
      color: #333;
      font-weight: 600;
      font-size: 29px;
      text-align: center;
    }

    .empty {
      width: 29px;
    }

    img {
      width: 29px;
      height: 29px;
    }
  }
  .sku_list {
    padding: 0 54px 130px 54px;
    .sku_list_detial {
      h2 {
        padding-top: 14px;
        padding-bottom: 22px;
        color: #333;
        font-weight: 600;
        font-size: 29px;
      }
      ul {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        li.noneActive {
          color: #cfcfcf;
          border: none;
          pointer-events: none;
        }
        li.active {
          color: #ff6c02;
          border: 1px solid #ff6c02;
          pointer-events: none;
        }
        li {
          width: 190px;
          height: 65px;
          margin: 0 29px 29px 0;
          overflow: hidden;
          color: #787878;
          font-size: 25px;
          line-height: 65px;
          text-align: center;
          text-overflow: ellipsis;
          border: 1px solid #e8e8e8;
          border-radius: 7px;
        }
        li:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
  .sub {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 634px;
    height: 91px;
    margin: 29px auto 29px;
    color: #fff;
    font-size: 36px;
    line-height: 91px;
    background: #ff6c02;
    border-radius: 45px;
  }
}
</style>
